<div class="add-market-form">
    <div class="form-row">
        <label>Market name</label>
        <input class="k-textbox" [(ngModel)]="name" name="name" autofocus />
    </div>
    <p class="error" *ngIf="error">{{ error }}</p>

    <div class="form-row" *ngIf="unassignedOptions.length">
        <label>Add unassigned services <span class="optional">(optional)</span></label>
        <kendo-multiselect #unassignedMultiSelect
                            [data]="filteredUnassignedOptions" [(value)]="selectedUnassigned"
                            textField="service" valueField="service" [valuePrimitive]="true"
                            [filterable]="true" (filterChange)="onUnassignedFilter($event)"
                            (valueChange)="onUnassignedValueChange(unassignedMultiSelect)"
                            [autoClose]="false"
                            placeholder="Search services currently reported as Other...">
        </kendo-multiselect>
        <p class="hint">Currently unassigned - not counted toward any market.</p>
    </div>

    <div class="form-row" *ngIf="availableServices.length">
        <label>Move existing services in <span class="optional">(optional)</span></label>
        <kendo-multiselect #otherMarketsMultiSelect
                            [data]="filteredAvailableServices" [(value)]="selectedFromOtherMarkets"
                            textField="label" valueField="service" [valuePrimitive]="true"
                            [filterable]="true" (filterChange)="onAvailableFilter($event)"
                            (valueChange)="onAvailableValueChange(otherMarketsMultiSelect)"
                            [autoClose]="false"
                            placeholder="Search services currently in other markets...">
        </kendo-multiselect>
        <p class="hint">Selected services move out of their current market into this one.</p>
    </div>

    <kendo-dialog-actions [layout]="'normal'">
        <button kendoButton (click)="onCancel()">Cancel</button>
        <button kendoButton [primary]="true" [disabled]="!!error" (click)="onAdd()">{{ confirmLabel }}</button>
    </kendo-dialog-actions>
</div>
